/**
 * Value object для работы с датой
 */

class DateVO {
  date: Date;

  /**
   * @param datetimeString - дата в ввиде строки формата "2022-04-07 23:59:59"
   * @private
   */
  private constructor(datetimeString: string | null) {
    // Todo: setup checks for another datetime format
    if (!datetimeString) {
      this.date = new Date();
    } else {
      const chunkedDate = datetimeString.split(' ');
      chunkedDate[0] = chunkedDate[0].replace(/-/g, '/');
      this.date = new Date(chunkedDate.join(' '));
    }
  }

  /**
   * @param datetimeString - дата в ввиде строки формата "2022-04-07 23:59:59"
   */
  static create(datetimeString: string): DateVO {
    return new DateVO(datetimeString);
  }

  /**
   * Получение обьекта Date
   * @return Date
   */
  get(tzDefault?: boolean): Date {
    if (tzDefault) {
      return this.date;
    }
    return new Date(this.date.toLocaleString('en-US', { timeZone: 'Europe/Kiev' }));
  }
}

export default DateVO;
